export const getCallbackUrl = (customReturnUrl?: string) => {
  if (typeof window === "undefined") return "";

  let targetReturnPath = "";

  if (customReturnUrl) {
    // Check if the URL starts with http:// or https:// (case insensitive)
    const isAbsolute = /^https?:\/\//i.test(customReturnUrl);

    if (isAbsolute) {
      targetReturnPath = customReturnUrl;
    } else {
      // Ensure the relative URL starts with a single leading slash
      const cleanRelative = customReturnUrl.startsWith("/")
        ? customReturnUrl
        : `/${customReturnUrl}`;
      targetReturnPath = `${window.location.origin}${cleanRelative}`;
    }
  } else {
    // Fallback: Capture current path and query string with dynamic protocol check
    const currentPath = window.location.pathname;
    const currentSearch = window.location.search;
    targetReturnPath = `${window.location.origin}${currentPath}${currentSearch}`;
  }

  const returnUrl = encodeURIComponent(targetReturnPath);
  console.log("returnUrl", returnUrl);

  return `${window.location.origin}/payment/callback?return=${returnUrl}`;
};

export const getServiceConfirmCallback = (
  customReturnUrl?: string,
  paymentPurpose?: string,
) => {
  if (typeof window === "undefined") return "";

  let targetReturnPath = "";

  if (customReturnUrl) {
    // Check if the URL starts with http:// or https:// (case insensitive)
    const isAbsolute = /^https?:\/\//i.test(customReturnUrl);

    if (isAbsolute) {
      targetReturnPath = customReturnUrl;
    } else {
      // Ensure the relative URL starts with a single leading slash
      const cleanRelative = customReturnUrl.startsWith("/")
        ? customReturnUrl
        : `/${customReturnUrl}`;
      targetReturnPath = `${window.location.origin}${cleanRelative}`;
    }
  } else {
    // Fallback: Capture current path and query string with dynamic protocol check
    const currentPath = window.location.pathname;
    const currentSearch = window.location.search;
    targetReturnPath = `${window.location.origin}${currentPath}${currentSearch}`;
  }

  const returnUrl = encodeURIComponent(targetReturnPath);
  console.log("returnUrl", returnUrl);

  // Optional marker (e.g. "live_inspection") lets the confirmation page know
  // which product the completed payment belongs to.
  const purposeParam = paymentPurpose
    ? `&purpose=${encodeURIComponent(paymentPurpose)}`
    : "";

  return `${window.location.origin}/payment/callback/service?return=${returnUrl}${purposeParam}`;
};

/**
 * Appends the current route path and query parameters as a encoded 'return' query parameter
 * to a target URL.
 * * @param targetUrl The base callback URL (e.g., "/payment/callback/service" or "https://domain.com/callback")
 */
export const appendReturnUrl = (targetUrl: string): string => {
  if (typeof window === "undefined" || !targetUrl) return targetUrl || "";

  // 1. Capture current path and query string (e.g., /dashboard/billing?tab=history)
  const currentPath = window.location.pathname;
  const currentSearch = window.location.search;
  const returnUrl = encodeURIComponent(`${currentPath}${currentSearch}`);

  // 2. Parse the target URL to see if it already has existing query parameters
  const separator = targetUrl.includes("?") ? "&" : "?";

  return `${targetUrl}${separator}return=${returnUrl}`;
};
